// Shared GPS helpers — presentation only. All route intelligence lives in the P3 backend.
const API = process.env.REACT_APP_BACKEND_URL;

// Next-stop CTA resolver → EXISTING canonical client routes (P0/P1 inventory)
export const CTA_ROUTES = {
  ASK_CONCIERGE: { path: '/contact', label: 'Ask Your Auto Concierge' },
  START_ASSESSMENT: { path: '/assessment', label: 'Take the Assessment' },
  COMPARE_OPTIONS: { path: '/consultation/intake', label: 'Compare My Options' },
  BOOK_DRIVEN: { path: '/booking', label: 'Book Driven Service' },
  GROUP_PLAN: { path: '/intake/event-booking', label: 'Plan My Group Movement' },
  REQUEST_VEHICLE_ACCESS: { path: '/rentals/request', label: 'Request Vehicle Access' },
  ACQUIRE_VEHICLE: { path: '/consultation/intake', label: 'Start My Acquisition' },
  DISPOSE_REPLACE_VEHICLE: { path: '/consultation/intake', label: 'Review Replace Options' },
  MEMBERSHIP_REVIEW: { path: '/membership', label: 'Review Membership Fit' },
  BUSINESS_MOBILITY_REVIEW: { path: '/corporate', label: 'Business Mobility Review' },
  CONSULTATION: { path: '/consultation', label: 'Book a Consultation' },
  EDUCATION: { path: '/blog', label: 'Learn More About This Decision' },
  NO_ACTION: null, // no sales CTA — save / return / learn only
};

export const MODE_EXPLAIN = {
  DRIVEN: 'ACE handles the movement.',
  DRIVING: 'You control or access the vehicle.',
  HYBRID: 'Use both depending on what creates value in the moment.',
  DECISION: 'The next move is deciding what should be owned, accessed, replaced or left alone.',
  BUSINESS: 'The route coordinates mobility around an account, team or fleet objective.',
};

export const DESTINATION_OPTIONS = [
  { type: 'SAVE_TIME', label: 'Save time' },
  { type: 'BE_DRIVEN_MORE', label: 'Be driven more' },
  { type: 'DRIVE_SOMETHING_BETTER', label: 'Drive something better' },
  { type: 'OWN_SMARTER', label: 'Own smarter' },
  { type: 'SIMPLIFY_MY_GARAGE', label: 'Simplify my garage' },
  { type: 'ACCESS_WITHOUT_OWNING', label: 'Access without owning' },
  { type: 'UPGRADE_MY_VEHICLE', label: 'Upgrade my vehicle' },
  { type: 'SELL_REPLACE_A_VEHICLE', label: 'Sell / replace a vehicle' },
  { type: 'MOVE_MY_BUSINESS', label: 'Move my business' },
  { type: 'MOVE_MY_GROUP', label: 'Move my group' },
  { type: 'PLAN_AN_EXPERIENCE', label: 'Plan an experience' },
  { type: 'BUILD_A_FLEET', label: 'Build a fleet' },
  { type: 'REDUCE_MOBILITY_FRICTION', label: 'Reduce mobility friction' },
  { type: 'IM_NOT_SURE', label: "I'm not sure yet" },
];

export const PRIORITY_OPTIONS = ['TIME', 'CONVENIENCE', 'PRIVACY', 'EXPERIENCE', 'CONTROL',
  'CAPACITY', 'FLEXIBILITY', 'ECONOMICS', 'RESPONSIBILITY', 'OWNERSHIP'];

export const trackGps = (event, journeyId = '', meta = {}) => {
  try {
    fetch(`${API}/api/auto-lifestyle/gps/track`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, journey_id: journeyId, meta }),
    }).catch(() => {});
  } catch (_) {}
};

export const saveJourneyToken = (journeyId, token) => {
  try { localStorage.setItem(`als_route_${journeyId}`, token); } catch (_) {}
};
export const getJourneyToken = (journeyId) => {
  try { return localStorage.getItem(`als_route_${journeyId}`) || ''; } catch (_) { return ''; }
};
